import { render, staticRenderFns } from "./DomainSelecter.vue?vue&type=template&id=813c3ae4&scoped=true&"
import script from "./DomainSelecter.vue?vue&type=script&lang=js&"
export * from "./DomainSelecter.vue?vue&type=script&lang=js&"
import style0 from "./DomainSelecter.vue?vue&type=style&index=0&id=813c3ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813c3ae4",
  null
  
)

export default component.exports